
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/news/video",
      function () {
        return require("private-next-pages/en/news/video.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/news/video"])
      });
    }
  